module.exports = __webpack_public_path__ + "static/media/writing.afa56125.png";